import type { IconProps } from "../Icon.props";
import createWebIcon from "../createWebIcon";
import validateKeys from "../validateKeys";

export default function Message({ outline, ...props }: IconProps): JSX.Element {
  return outline ? (
    <Message.Outline {...props} />
  ) : (
    <Message.Solid {...props} />
  );
}

Message.Outline = function Outline({ name, ...props }: IconProps) {
  const Icon = createWebIcon({
    ...props,
    name: `${name}Outline`,
    path: (
      <>
        <path
          d="M17.9028 8.85156L13.4596 12.4646C12.6201 13.1306 11.4389 13.1306 10.5994 12.4646L6.11865 8.85156"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          className="icon-outline"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16.9089 21C19.9502 21.0084 22 18.5095 22 15.4384V8.57001C22 5.49883 19.9502 3 16.9089 3H7.09114C4.04979 3 2 5.49883 2 8.57001V15.4384C2 18.5095 4.04979 21.0084 7.09114 21H16.9089Z"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          className="icon-outline"
        />
      </>
    ),
  });

  return <Icon {...validateKeys(props)} />;
};

Message.Solid = function Solid({ name, ...props }: IconProps) {
  const Icon = createWebIcon({
    ...props,
    name: `${name}Solid`,
    path: (
      <>
        {/**
         * Enter the contents of your SVG here without the <svg> tag.
         * For solid icons, be sure to add `className="icon-primary"`
         * and `className="icon-secondary"` to show the two-tone
         * aspect of the icon if necessary.
         */}
      </>
    ),
  });

  return <Icon {...validateKeys(props)} />;
};
